import { Component, Input, Output, EventEmitter, SimpleChanges, HostListener } from '@angular/core';

export interface IModalData {
  class: string;
  id: string;
  role: string;
  ariaLabelledby: string;
  modal: {
    class: string
  };
  header?: {
    class: string,
    title: {
      text: string,
      id: string
    },
    subTitle?: {
      text: string,
      id: string
    },
    inlineBtn?: {
      class?: string,
      id: string
      callback?: () => void
    }
  };
  close?: {
    ariaLabel: string
  }
  body?: {
    class: string,
    subClass?: string,
    text: string[]
  };
  footer?: {
    class: string,
    buttons: {
      class: string,
      wrapperClass?: string,
      text: string,
      id: number,
      callback?: () => void,
      disabled?: () => boolean,
    }[]
  };
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  modalOnCheckboxElement = true;
  @Input() componentData: IModalData;
  @Input() showModal = false;

  @Output("closeModal") closeModal: EventEmitter<any> = new EventEmitter();
  @Output("btnCallback1") btnCallback1: EventEmitter<any> = new EventEmitter();
  @Output("btnCallback2") btnCallback2: EventEmitter<any> = new EventEmitter();

  private focusHistory: HTMLElement[] = [];
  referencesOpened = false;

  ngOnChanges(changes: SimpleChanges) {
    if (this.showModal) {
      this.focusHistory.push(document.querySelector('*:focus'));
    } else {
      this.focusHistory.pop()?.focus();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  clickedOut(event: any) {
    this.closeModal.emit()
  }

  onButtonClick(id, data): void {
    if (data?.callback) {
      data.callback();
      return;
    }

    switch (id) {
      case 1:
        this.btnCallback1 ? this.btnCallback1.emit() : '';
        break;
      case 2:
        this.btnCallback2 ? this.btnCallback2.emit() : '';
        this.closeModal.emit(this.modalOnCheckboxElement);
        break;
      default:
        break;
    }
  }

  onCloseModal(): void {
    if (this.componentData.header.inlineBtn.callback) {
      this.componentData.header.inlineBtn.callback();
    }
    this.closeModal.emit();
  }
}
